<template>
    <div class="">
        <b-container fluid>
            <h1>HRM Request Query</h1>

            <b-row>
              <b-col cols="12" lg="4">
                <BaseTextInput v-model="criteria.mdhTrackingId" 
                  :v="$v.criteria.mdhTrackingId"
                  label="MDH Tracking ID"
                  tip=""
                  slug="mdhTrackingId"/>
              </b-col>
            </b-row>
          <hr/>
              <b-row class="mb-3">
                <b-col>
                  <b-button type="button" variant="primary" @click="search">
                    <b-spinner small v-show="loading" class="mr-2"/>
                    Search
                  </b-button>
                </b-col>

                <b-col cols="12" lg="6" class="my-1">
                  <b-form-group
                      label="Filter"
                      label-cols-sm="3"
                      label-align-sm="right"
                      label-size="sm"
                      label-for="filterInput"
                      class="mb-0">
                    <b-input-group size="sm">
                      <b-form-input
                          v-model="filter"
                          type="search"
                          id="filterInput"
                          placeholder="Type to Search"></b-form-input>
                      <b-input-group-append>
                        <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>
              </b-row>
        </b-container>
        <b-table hover small responsive show-empty
                 :fields="fields"
                 :items="requests"
                 :busy="loading">
            <template #table-caption></template>
            <template v-slot:cell(actions)="row">
                <b-button size="sm" @click="editItem(row.item)" class="mr-1">
                    edit
                </b-button>
            </template>
            <template v-slot:no-data>
                <p>No requests found.</p>
            </template>

            <template v-slot:empty="scope">
                <p>No requests found.</p>
            </template>

            <div slot="table-busy" class="text-center text-danger my-2">
                <b-spinner class="align-middle" style="margin-right:5px; margin-top:12px;"></b-spinner>
                <strong>Loading, Please Wait...</strong>
            </div>
        </b-table>
        <div class="overflow-auto">

            <b-pagination
                    v-if="this.requests.length > perPage"
                    v-model="currentPage"
                    :total-rows="totalRows"
                    :per-page="perPage"
                    align="fill"
                    size="sm"/>
        </div>
    </div>
</template>
<script>
import axios from "axios"
import { required } from 'vuelidate/lib/validators'
import pageTitle from '@/mixins/pageTitle'

export default {
  title: 'HRM MDH Tracking ID Query',
  data: () => ({
    loading: false, 
    loadingDownload: false,
    loaded: false,
    perPage: 10,
    currentPage: 1,
    totalRows: 0,
    filter: null,
    fields: [
        {key: 'mdhTrackingId', sortable: true, label: 'Number'},
        {key: 'divisionCode', sortable: true, label: 'Division'},
        {key: 'formattedStatus', sortable: true, label: 'Lifecycle Status'},
        {key: 'lastUpdatedDateTime', sortable: true, label: 'Last Updated Date'},
        {key: 'actions', label: 'Actions'}
    ],
    criteria: {
      mdhTrackingId: null,
    },
    requests: [],
  }),
  mixins: [
    pageTitle
  ],
  validations: {
    criteria: {
      mdhTrackingId: { required },
    }
  },

  methods: {
    search() {
          this.loading = true
          this.loaded = false
          this.requests = []
          axios.post(`${process.env.VUE_APP_API_BASE_URL}/report/tracking-search`, this.criteria.mdhTrackingId)
          .then(response => { 
            this.requests = response.data
            this.loaded = true
            this.loading = false
          })
    },
      editItem(item){
          this.$router.push({ name: 'admin-edit', params: { id: item.id } })
      }
  }
 }
</script>

<style>

</style>
